// 表单配置
export default [
    {
        path: '/formConfiguration',
        component: resolve => require(['@/pages/formConfiguration/formHomePage.vue'], resolve),
        meta: {
            title: '表单配置'
        }
    },
    {
        path: '/formConfigurationList',
        component: resolve => require(['@/pages/formConfiguration/formConfigurationList.vue'], resolve),
        meta: {
            title: '表单列表'
        }
    },
    {
        path: '/formConfigurationAudit',
        component: resolve => require(['@/pages/formConfiguration/formConfigurationAudit.vue'], resolve),
        meta: {
            title: '表单审核'
        }
    },
    {
        path: '/dataStatistics',
        component: resolve => require(['@/pages/formConfiguration/dataStatistics.vue'], resolve),
        meta: {
            title: '表单列表'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/formConfiguration.js